import type { enWeapons } from './en-weapons';

/** Turkish strings — weapon readability + combat HUD. */
export const trWeapons: Record<keyof typeof enWeapons, string> = {
  'wrarity.common': 'SIRADAN',
  'wrarity.rare': 'NADİR',
  'wrarity.epic': 'EPİK',

  'hud.super': 'SÜPER',
  'hud.superReady': 'SÜPER HAZIR',
  'hud.dash': 'DASH',
  'wstat.crateLabel': '{name} · {rarity}',

  'wstat.type.direct': 'DİREKT',
  'wstat.type.lobbed': 'LOBLU',
  'wstat.type.homing': 'GÜDÜMLÜ',
  'wstat.type.aoe': '{type} + ALAN',
  'wstat.perShot': 'HASAR / ATIŞ',
  'wstat.areaDps': 'ALAN DPS',
  'wstat.areaValue': '+{dps} · r{r}',
  'wstat.noteLive': 'Şu an: kartlar, ort. kritik, {m}× namlu, raf ×{r}',
  'wstat.noteIf': 'Takılırsa: kartlar, ort. kritik, {m}× namlu, raf ×{r}',
};
